"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.typographyOverrides = void 0;
var typographyOverrides = {
  MuiTypography: {
    defaultProps: {
      variant: 'bodyLarge',
      variantMapping: {
        d1: 'h1',
        d2: 'h1',
        lead: 'p',
        blockquote: 'blockquote',
        action: 'p',
        actionBold: 'p',
        bodyLarge: 'p',
        bodySmall: 'p',
        footnote: 'p',
        pretitle: 'p',
        label: 'label',
        labelBold: 'label',
        option: 'span',
        caption: 'p'
      }
    }
  }
};
exports.typographyOverrides = typographyOverrides;